// extracted by mini-css-extract-plugin
module.exports = {"arrowBody":"FormBackArrow_arrowBody__31s2K"};